import { createContext, useState, useContext, useEffect } from "react";
import { loginUser, logoutUser, getCurrentUser } from "../services/authService";

const AuthContext = createContext();
export { AuthContext };

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(() => {
    // Try to get user from localStorage on initial load
    const storedUser = localStorage.getItem('user');
    return storedUser ? JSON.parse(storedUser) : null;
  });

  useEffect(() => {
    const currentUser = getCurrentUser();
    if (currentUser) setUser(currentUser);
  }, []);

  const login = async (credentials) => {
    const loggedInUser = await loginUser(credentials);
    if (loggedInUser && loggedInUser.status === "ok") {
      setUser(loggedInUser.data);
      localStorage.setItem('user', JSON.stringify(loggedInUser.data));
      return { status: "ok" };
    } else {
      return {
        status: 0,
        message: loggedInUser?.message || "Invalid credentials."
      };
    }
  };

  const logout = () => {
    logoutUser();
    setUser(null);
    localStorage.removeItem('user'); // Remove user from storage
  };

  return (
    <AuthContext.Provider value={{ user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
